import React from 'react'
import OrderManagementFormPageContainer from './OrderManagementFormPageContainer'

export class OrderManagementFormPage extends React.Component{
    render(){
        return (
            <OrderManagementFormPageContainer { ...this.props} />
        )
    }
}